import type { NodePropertySchema } from '../../../types/node-properties';

const schema: NodePropertySchema = {
  nodeType: 'twilio',
  version: '2.1.0',
  properties: [
    // Properties will be defined based on n8n equivalents
  ]
};

export default schema;
